<template>
  <div class="vx-col w-full mb-base m-auto">
    <!-- All Tab for Master Setting Menu -->
    <vx-card :title="$t('labels.masters_settings')" class="mastercard materstab">
      <vs-tabs position="left" color="primary" class id="check">
        <vs-tab :label="$t('labels.hobi_charge')" @click="sparetimecharge = true">
          <sparetimecharge v-if="sparetimecharge"></sparetimecharge>
        </vs-tab>
        <!-- <vs-tab :label="$t('labels.sparetime_charge')" @click="sparetimecharge = true">
          <sparetimecharge v-if="sparetimecharge"></sparetimecharge>
        </vs-tab> -->
        <vs-tab :label="$t('labels.service_charge')" @click="serviceprovidercharge = true">
          <serviceprovidercharge v-if="serviceprovidercharge"></serviceprovidercharge>
        </vs-tab>
        <vs-tab :label="$t('labels.experience')" @click="experience = true">
          <experience v-if="experience"></experience>
        </vs-tab>
        <vs-tab :label="$t('labels.terms_help')" @click="termsandhelp = true">
          <termsandhelp v-if="termsandhelp"></termsandhelp>
        </vs-tab>
      </vs-tabs>
    </vx-card>
    <!-- All Tab for Master Setting Menu -->
  </div>
</template>
      
<script>
import sparetimecharge from "@/components/master/sparetime-charge.vue";
import experience from "@/components/master/experience.vue";
import serviceprovidercharge from "@/components/master/service-provider-charge.vue";
import termsandhelp from "@/components/master/terms-and-condition-help-and-support.vue";

export default {
  mounted() {
    if (window && window.innerWidth < 480) {
      $("#check").addClass("vs-tabs-position-top");
      $("#check").removeClass("vs-tabs-position-left");
    }
  },

  computed: {
    smallScreen() {
      if (window.innerWidth < 480) {
        // this.$set(this.screen_size, "width", window.innerWidth)
        this.$("#check").addClass("vs-tabs-position-top");
        this.$("#check").removeClass("vs-tabs-position-left");
        return true;
      }
      return false;
    }
  },

  components: {
    sparetimecharge: sparetimecharge,
    experience:experience,
    serviceprovidercharge:serviceprovidercharge,
    termsandhelp:termsandhelp
  },

  data() {
    return {
      sparetimecharge: true,
      experience:false,
      serviceprovidercharge:false,
      termsandhelp:false,
    };
  }
};
</script>